export enum Status {
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE', //Aguardando ass.
  FORMALIZATION = 'FORMALIZATION', //Em análise.
  MADE_EFFECTIVE = 'MADE_EFFECTIVE', //Efetivado.
  REJECTED = 'REJECTED', //Negado.
  PENDING_DOCUMENTS = 'PENDING_DOCUMENTS', //Pendência doc.
  PENDING_SIGN = 'PENDING_SIGN', //Pendência ass.
  PENDING_DOCUMENTS_SIGN = 'PENDING_DOCUMENTS_SIGN', //Pendências.
  REFUSED = 'REFUSED', //Recusado.
  ENDORSED = 'ENDORSED', //Em análise.
  PENDING_PURCHASE_MARGIN = 'PENDING_PURCHASE_MARGIN', //Pendência margem.
  PENDING_PURCHASE_MARGIN_WRONG_PROPOSAL = 'PENDING_PURCHASE_MARGIN_WRONG_PROPOSAL', //Margem prop. errada.
  REFUSED_EXPIRED = 'REFUSED_EXPIRED', //Expirado.
}
